import {
    BrandElementsFontsClass,
    IBrandElementFont,
    IDesignElementsFonts,
} from '../interfaces/brand-magic.interface';

export const mapFontFamilies = (
    key: BrandElementsFontsClass,
    brandElementsFonts: IDesignElementsFonts,
) => {
    return brandElementsFonts[key]?.map((obj) => obj.fontFamily) || [];
};

export const mapBrandDefinedFonts = (
    key: BrandElementsFontsClass,
    brandElementsFonts: IDesignElementsFonts,
) => {
    if (brandElementsFonts[key]) {
        const fonts = brandElementsFonts[key];
        const brandDefinedFonts: IBrandElementFont[] = [];
        if (fonts) {
            fonts.forEach((font) => {
                if (font.url) brandDefinedFonts.push(font);
            });
            return brandDefinedFonts;
        }
        return [];
    }
    return [];
};
